import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Per-route titles & descriptions (bilingual, optimized for Arabic search)
// Keys are pathname prefixes.
const ROUTE_META = {
  "/": {
    title: "عبدالله | علم القهوة — أكاديمية القهوة المتخصصة من البذرة حتى الفنجان",
    desc: "علم القهوة: موسوعة عبدالله الكاساني الشاملة للقهوة المتخصصة — وصفات، طرق تحضير، حاسبة نسب، أكاديمية SCA باللغة العربية. اكتشف اكاديمية عبدالله وكل ما تحتاجه عن البن.",
  },
  "/journey": {
    title: "رحلة القهوة من البذرة إلى الفنجان | علم القهوة — عبدالله",
    desc: "زراعة، حصاد، معالجة، تحميص وتحضير — رحلة كاملة لحبة القهوة بأسلوب علمي بسيط من أكاديمية عبدالله.",
  },
  "/academy": {
    title: "أكاديمية عبدالله للقهوة | دورة الباريستا والقهوة المتخصصة SCA",
    desc: "اكاديمية عبدالله لتعليم القهوة: مهارات الباريستا، الإسبريسو، اللاتيه آرت، تحضير V60، التحميص، والمعايير الدولية SCA — كل شيء بالعربية.",
  },
  "/encyclopedia": {
    title: "موسوعة علم القهوة | معايير SCA كاملة بالعربية — عبدالله",
    desc: "موسوعة شاملة لعلم القهوة: التذوق (Cupping)، نظام النقاط 100، عجلة النكهات، مخطط التحضير الذهبي، معايير الماء، علم التحميص والإسبريسو.",
  },
  "/countries": {
    title: "دول منشأ القهوة وأصنافها | علم القهوة",
    desc: "16 دولة منشأ للقهوة: الارتفاع، الأصناف، موسم الحصاد، النكهة المميزة لكل بلد — من إثيوبيا إلى اليمن والبرازيل.",
  },
  "/calculator": {
    title: "حاسبة نسب القهوة | Brew Ratio Calculator — كل طرق التحضير",
    desc: "احسب نسبة القهوة والماء لكل طريقة تحضير: V60، Chemex، فرنش بريس، إيروبرس، إسبريسو، موكا، كولد برو، وتركية. سهل ودقيق.",
  },
  "/recipes": {
    title: "وصفات القهوة | مشروبات عبدالله ومجتمع علم القهوة",
    desc: "وصفات قهوة منتقاة من عبدالله ومن مجتمع علم القهوة: لاتيه، كابتشينو، إسبريسو، فلات وايت، V60، آيس سبانش لاتيه، وغيرها.",
  },
  "/assistant": {
    title: "مساعد القهوة الذكي AI Barista | علم القهوة",
    desc: "اسأل أي شيء عن القهوة: التحضير، التحميص، الباريستا، الأصول، والمعايير. مساعد ذكي يجاوبك فوراً بالعربية والإنجليزية.",
  },
  "/about": {
    title: "عبدالله الكاساني | عن أكاديمية علم القهوة",
    desc: "تعرّف على عبدالله الكاساني، باريستا وخبير قهوة سعودي معتمد من SCA. رحلته وشهاداته ومسيرته في عالم القهوة المتخصصة.",
  },
};

export function useSEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = ROUTE_META[pathname] || ROUTE_META["/"];
    document.title = meta.title;

    const setMeta = (selector, attr, content) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("meta");
        const [name, val] = selector.match(/\[([^=]+)="([^"]+)"\]/)?.slice(1) || [];
        if (name && val) el.setAttribute(name, val);
        document.head.appendChild(el);
      }
      el.setAttribute(attr, content);
    };

    setMeta('meta[name="description"]', "content", meta.desc);
    setMeta('meta[property="og:title"]', "content", meta.title);
    setMeta('meta[property="og:description"]', "content", meta.desc);
    setMeta('meta[name="twitter:title"]', "content", meta.title);
    setMeta('meta[name="twitter:description"]', "content", meta.desc);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `https://abdullah-coffee-science.academy${pathname}`);

    // GA4 page_view event on SPA route change
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname,
        page_title: meta.title,
        page_location: window.location.href,
      });
    }
  }, [pathname]);
}
